import React from "react";
import FilterRow from "./FilterRow";
import {FaCheckCircle, FaRedoAlt, FaRandom, FaExclamationTriangle, FaTimesCircle, FaLayerGroup} from "react-icons/fa";

export const StatusCodeFilters = ({handleSwitchToggle, state}) => {
    const t = state.toggles;
    return (
        <FilterRow
            label="Status code"
            items={[
                {label: "Just 200", icon: FaCheckCircle, color: "#20c997", checked: t.just200Checked, onChange: handleSwitchToggle("just200Checked"), key: "just200"},
                {label: "2xx", icon: FaCheckCircle, color: "#20c997", checked: t.status200Checked, onChange: handleSwitchToggle("status200Checked"), key: "2xx"},
                {label: "301", icon: FaRedoAlt, color: "#0d6efd", checked: t.status301Checked, onChange: handleSwitchToggle("status301Checked"), key: "301"},
                {label: "3xx", icon: FaRandom, color: "#0d6efd", checked: t.status3xxChecked, onChange: handleSwitchToggle("status3xxChecked"), key: "3xx"},
                {label: "4xx", icon: FaExclamationTriangle, color: "#fd7e14", checked: t.status4xxChecked, onChange: handleSwitchToggle("status4xxChecked"), key: "4xx"},
                {label: "5xx", icon: FaTimesCircle, color: "#dc3545", checked: t.status5xxChecked, onChange: handleSwitchToggle("status5xxChecked"), key: "5xx"},
                {label: "Long redirect chain", icon: FaLayerGroup, color: "#6366f1", checked: t.longRedirectChainChecked, onChange: handleSwitchToggle("longRedirectChainChecked"), key: "longRedirectChain"}
            ]}
        />
    );
};
